export class ApplicationOnboardingStateFunctionUtils {
    static $inject = ['application', 'flowBucket', 'isAnyUsersOnApplication', 'applicationService2', 'channels'];
    constructor(application, flowBucket, isAnyUsersOnApplication, applicationService2, channels) {
        this.application = application;
        this.flowBucket = flowBucket;
        this.isAnyUsersOnApplication = isAnyUsersOnApplication;
        this.applicationService2 = applicationService2;
        this.channels = channels;
    }
    async init() {
        this.applicationStepsRules = await this.generateOnboardingStepperRules();
    }
    async generateOnboardingStepperRules() {
        const isBotOnline = await this.applicationService2.isOnline(this.application);
        return [
            {
                rule: this.flowBucket.length > 4,
                ruleIndex: 0,
                description: 'isFlowCreated',
            },
            {
                rule: isBotOnline,
                ruleIndex: 1,
                description: 'isFlowPublished',
            },
            {
                rule: this.isAnyUsersOnApplication,
                ruleIndex: 2,
                description: 'isTestFlowDone',
            },
            {
                rule: this.channels.length > 0,
                ruleIndex: 3,
                description: 'isAnyChannelEnabled',
            },
        ];
    }
    isCurrentStepCompleted(rule) {
        return rule;
    }
}
ApplicationOnboardingStateFunctionUtils.$inject = ['application', 'flowBucket', 'isAnyUsersOnApplication', 'applicationService2', 'channels'];
